/**
 * Raised money formatter for dynamic JS updates (cart, volume pricing, etc).
 * Instant Trade Quote (.tq-root) is excluded.
 */
(function () {
  function padCents(n) {
    var s = String(Math.abs(parseInt(n, 10) || 0));
    return s.length < 2 ? '0' + s : s.slice(0, 2);
  }

  function formatCents(cents, symbol) {
    cents = Math.round(Number(cents) || 0);
    var neg = cents < 0;
    cents = Math.abs(cents);
    var dollars = Math.floor(cents / 100);
    var rem = cents % 100;
    var dollarsStr = dollars.toLocaleString('en-US');
    var sym = symbol || '$';
    return (
      (neg ? '-' : '') +
      '<span class="ri-money" data-ri-cents="' +
      (neg ? -cents : cents) +
      '">' +
      '<span class="ri-money__symbol" aria-hidden="true">' +
      sym +
      '</span>' +
      '<span class="ri-money__dollars" aria-hidden="true">' +
      dollarsStr +
      '</span>' +
      '<span class="ri-money__cents" aria-hidden="true">' +
      padCents(rem) +
      '</span>' +
      '<span class="visually-hidden">' +
      (neg ? '-' : '') +
      sym +
      dollarsStr +
      '.' +
      padCents(rem) +
      '</span>' +
      '</span>'
    );
  }

  /** Parse "$1,234.56" / "1,234.56" into cents */
  function parseMoneyString(str) {
    if (str == null) return null;
    var raw = String(str).replace(/<[^>]*>/g, '').trim();
    if (!raw || raw.indexOf('ri-money') !== -1) return null;
    var neg = /^-/.test(raw.replace(/[^0-9.,\-]/g, ''));
    var cleaned = raw.replace(/[^0-9.,]/g, '');
    if (!cleaned) return null;
    var parts = cleaned.split('.');
    var dollars = parts[0].replace(/,/g, '');
    var cents = parts[1] ? parts[1].slice(0, 2) : '00';
    if (cents.length === 1) cents += '0';
    var total = parseInt(dollars || '0', 10) * 100 + parseInt(cents || '0', 10);
    return neg ? -total : total;
  }

  function upgradeElement(el) {
    if (!el || el.closest('.tq-root, .tq-trade-calculator, [data-ri-skip-raised-money]')) return;
    if (el.querySelector && el.querySelector('.ri-money')) return;
    if (el.classList && el.classList.contains('ri-money')) return;

    var cents = el.getAttribute('data-ri-cents');
    if (cents == null || cents === '') {
      cents = parseMoneyString(el.textContent);
    } else {
      cents = parseInt(cents, 10);
    }
    if (cents == null || isNaN(cents)) return;

    var symbol = el.getAttribute('data-ri-symbol') || '$';
    el.innerHTML = formatCents(cents, symbol);
  }

  function upgradeRoot(root) {
    root = root || document;
    root.querySelectorAll('[data-ri-cents]').forEach(upgradeElement);
  }

  window.RIMoney = {
    formatCents: formatCents,
    parseMoneyString: parseMoneyString,
    upgradeElement: upgradeElement,
    upgradeRoot: upgradeRoot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      upgradeRoot(document);
    });
  } else {
    upgradeRoot(document);
  }

  document.addEventListener('cart:updated', function () {
    upgradeRoot(document);
  });
})();
